<script setup>
import { useI18n } from 'vue-i18n';
import RealEstateFinanceCommissionAllocationRow from './RealEstateFinanceCommissionAllocationRow.vue';
import RealEstateFinanceCommissionAllocationSummary from './RealEstateFinanceCommissionAllocationSummary.vue';

defineProps({
  beneficiaries: { type: Array, default: () => [] },
  installment: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  rateio: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['download-sheet', 'release', 'transfer']);
const { t } = useI18n();
</script>

<template>
  <section
    data-testid="finance-installment-beneficiaries"
    class="rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card"
  >
    <h3 class="font-semibold text-lais-text">
      {{ t('REAL_ESTATE_FINANCE.ALLOCATION.TITLE') }}
    </h3>
    <RealEstateFinanceCommissionAllocationSummary
      class="mt-4"
      :installment="installment"
      :rateio="rateio"
      @download-sheet="emit('download-sheet', $event)"
    />
    <p v-if="!beneficiaries.length" class="mt-4 text-sm text-lais-text-muted">
      {{ t('REAL_ESTATE_FINANCE.DETAIL.NO_BENEFICIARIES') }}
    </p>
    <div v-else class="mt-4">
      <RealEstateFinanceCommissionAllocationRow
        v-for="beneficiary in beneficiaries"
        :key="`${beneficiary.tipo || 'usuario'}-${beneficiary.empresa?.id || beneficiary.empresa_id || beneficiary.usuario?.id || beneficiary.usuario_id}`"
        :beneficiary="beneficiary"
        :loading="loading"
        @release="emit('release', $event)"
        @transfer="emit('transfer', $event)"
      />
    </div>
  </section>
</template>
